export default __webpack_public_path__ + "static/media/012-truck.fee012a1.svg";